import { CSVLink } from "react-csv";
import { Button, Typography } from "antd";

import { useAppSelector } from "store/hook";

import { useReportStatistic } from "Components/Report/queries";

const { Text } = Typography;

const ExportCSV = () => {
  const { filterForm, isFetchingAPI } = useAppSelector((status) => status.report);
  const { loginCid, stateCid, level } = useAppSelector((status) => status.global);
  const { data: reportStatistic, isLoading } = useReportStatistic(filterForm, loginCid, stateCid, level);
  const account = (reportStatistic?.response?.account_level?.status || []).map(
    ({
      start,
      end,
      start_utc,
      end_utc,
      interface: { lte, wan },
      system: {
        alarm: { offline_devices, warning_devices, critical_devices },
        uptime,
      },
    }) => {
      return {
        ID: "Account Level",
        Start: start,
        End: end,
        "Start UTC": start_utc,
        "End UTC": end_utc,
        "Cellular Tx": lte.tx_kbytes,
        Offline: offline_devices,
        Warning: warning_devices,
        Critical: critical_devices,
        "System Uptime": uptime,
        "Cellular Rx": lte.rx_kbytes,
        "Signal Fair": lte.signal_fair_devices,
        "Signal Good": lte.signal_good_devices,
        "Signal Poor": lte.signal_poor_devices,
        "Cellular Uptime": lte.uptime,
        "Cellular RSRP": lte.rsrp,
        "Cellular RSSI": lte.rssi,
        "EWAN Tx": wan.tx_kbytes,
        "EWAN Rx": wan.rx_kbytes,
        "EWAN Uptime": wan.uptime,
      };
    },
    []
  );
  const device = Object.entries(reportStatistic?.response?.device_level || {})
    .map(([ID, key]) => {
      return key.status.map(
        ({
          start,
          end,
          start_utc,
          end_utc,
          interface: { lte, wan },
          system: {
            alarm: { offline, warning, critical },
            uptime,
          },
        }) => ({
          ID,
          Start: start,
          End: end,
          "Start UTC": start_utc,
          "End UTC": end_utc,
          "Cellular Tx": lte.tx_kbytes,
          Offline: offline,
          Warning: warning,
          Critical: critical,
          "System Uptime": uptime,
          "Cellular Rx": lte.rx_kbytes,
          "Signal Fair": lte.signal_fair,
          "Signal Good": lte.signal_good,
          "Signal Poor": lte.signal_poor,
          "Cellular Uptime": lte.uptime,
          "Cellular RSRP": lte.rsrp,
          "Cellular RSSI": lte.rssi,
          "EWAN Tx": wan.tx_kbytes,
          "EWAN Rx": wan.rx_kbytes,
          "EWAN Uptime": wan.uptime,
        })
      );
    })
    .reduce((acc, curr) => [...acc, ...curr], []);

  return (
    <Button disabled={isFetchingAPI}>
      <CSVLink data={[...account, ...device]}>
        {/* <Text >Export</Text> */}
        Export
      </CSVLink>
    </Button>
  );
};

export default ExportCSV;
